import { render, staticRenderFns } from "./UsersRateeCard.vue?vue&type=template&id=4595193f&"
import script from "./UsersRateeCard.vue?vue&type=script&lang=ts&"
export * from "./UsersRateeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports